<nz-switch
  [(ngModel)]="checked"
  [nzDisabled]="disabled()"
  [nzSize]="nzSize()"
  [attr.data-size]="size()">
</nz-switch>
